import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  mobileContent: {
    padding: 0,
  },

  mobileTitle: {
    padding: "0px",
  },

  mobileSlide: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing.space16,
    width: "100%",
  },

  mobileImageArea: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },

  mobileTextArea: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: theme.spacing.space8,
  },

  dotRow: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing.space8,
    justifyContent: "center",
    alignItems: "center",
  },

  dot: {
    width: 6,
    height: 6,
    borderRadius: "50%",
    background: theme.colors.TextGray,
    border: "none",
    padding: 0,
    transition: "all 0.3s ease",
  },

  dotActive: {
    width: 32,
    borderRadius: 4,
    background: theme.colors.TextDefault,
  },

  mobileVideoArea: {
    width: "100%",
    height: "100%",
  },

  videoIframe: {
    aspectRatio: "16 / 9",
    width: "100%",
    height: "100%",
    border: "none",
  },

  selected: {
    outline: `2px solid ${theme.colors.Border4}`,
  },

  descLarge: {
    textAlign: "left",
    color: theme.colors.TextSilver,
  },
}));
